export default __webpack_public_path__ + "static/media/keyFeature_3.8b5e7f96.svg";